<template>
    <div class="h5bg" style="position:relative;">
        <div style="height: 10px;"></div>
        <div style="padding:20px;background-color: #fff; margin:0 10px; border-radius: 6px;">
            <el-form ref="form" :model="enterInfo" label-position="left" label-width="100px">
                <el-form-item label="联系人" style="margin-bottom: 0;">{{ enterInfo.linkman }}</el-form-item>
                <el-divider></el-divider>
                <el-form-item label="联系电话" style="margin-bottom: 0;">{{ enterInfo.tel }}</el-form-item>
                <el-divider></el-divider>
                <el-form-item label="预约项目" style="margin-bottom: 0;">{{ enterInfo.project_name }}</el-form-item>
                <el-divider></el-divider>
                <el-form-item v-if="type != 3" :label="type == 1 ? '预约场馆' : type == 2 ? '预约场地' : ''"
                    style="margin-bottom: 0;">{{ enterInfo.table_name }}</el-form-item>
                <el-divider v-if="type != 3"></el-divider>
                <el-form-item v-if="type == 3" label="预约课程" style="margin-bottom: 0;">{{ enterInfo.table_name
                    }}</el-form-item>
                <el-divider v-if="type == 3"></el-divider>
                <el-form-item v-if="type != 3" label="预约教练" style="margin-bottom: 0;">{{ enterInfo.teacher_name
                    }}</el-form-item>
                <el-divider v-if="type != 3"></el-divider>
                <el-form-item v-if="type == 3 && enterInfo.teacher_name" label="预约教练" style="margin-bottom: 0;">{{
                    enterInfo.teacher_name }}</el-form-item>
                <el-divider v-if="type == 3 && enterInfo.teacher_name"></el-divider>
                <el-form-item label="预约日期" style="margin-bottom: 0;">{{ enterInfo.reserve_date }}</el-form-item>
                <el-divider></el-divider>
                <el-form-item label="起始时间" style="margin-bottom: 0;">{{ enterInfo.start_time }}</el-form-item>
                <el-divider></el-divider>
                <el-form-item label="结束时间" style="margin-bottom: 0;">{{ enterInfo.end_time }}</el-form-item>
                <el-divider></el-divider>
                <el-form-item label="备注" style="margin-bottom: 0;">{{ enterInfo.remark }}</el-form-item>
            </el-form>


        </div>


        <div style="height:20px"></div>
    </div>
</template>

<script>

export default {
    data() {
        return {
            openid: "",
            pmid: 0,
            type: 1,
            loading: false,

            enterInfo: {
                firm_name: "",
                firm_num: "",
                address: "",
                firm_principal: "",
                tel: "",
                pjson: {
                    xjh: ""
                },
            },
            zphid: 0,
            job_info_list: [],
            job: { "post": "", "num": 3, boy: "", girl: "", "specialty": "", "culture": "", "foreignLanguage": "", "computer": "", jintie: "", salary: "" },
            fileList: [],
            cgList: [],
            teacherList: [],
            courseList: [],
            projectList: []
        };
    },
    mounted() {
        let _this = this
        document.title = "预约详情"

        this.openid = this.$route.query.openid
        this.pmid = this.$route.query.pmid
        this.type = this.$route.query.type || 1

        if (this.$route.query.row) {
            let paramsrow = JSON.parse(decodeURIComponent(this.$route.query.row))
            this.enterInfo = paramsrow

        }
        this.$nextTick(() => {
            _this.$forceUpdate()
        })
    },
    methods: {
       
        handleChange(e) {
            this.courseList.map(a => {
                if (a.id == e) {
                    this.enterInfo.teacher_id = a.teacher_id
                    this.enterInfo.teacher_name = a.teacher_name
                }
            })
        },
       
        addJob() {
            this.job_info_list.push({ ...this.job })
            this.$nextTick(e => {
                $(".h5bg").scrollTop(99999)
            })
        },
        removeJob(i) {
            this.job_info_list.splice(i, 1)
        },

        uploadFiles(e) {
            this.fileList.push(e)
        },
        removeImg(idx) {
            this.fileList.splice(idx, 1)
        },
        checkEnterSuccess() {

        },

        saveForm() {
            if (!this.enterInfo.linkman.trim()) {
                this.$message({ message: "请输入联系人姓名", type: 'error', customClass: "toast", duration: 2000 });
                return
            }

            if (!this.enterInfo.tel.trim()) {
                this.$message({ message: "请输入联系人电话", type: 'error', customClass: "toast", duration: 2000 });
                return
            } else {
                let myreg = /^[1][2,3,4,5,6,7,8,9][0-9]{9}$/;
                if (!myreg.test(this.enterInfo.tel)) {
                    this.$message({ message: "请输入正确的手机号", type: 'error', customClass: "toast", duration: 2000 });
                    return;
                }
            }
            if (!this.enterInfo.project_id) {
                this.$message({ message: "请选择体育项目", type: 'error', customClass: "toast", duration: 2000 });
                return
            }
            if (!this.enterInfo.table_id) {
                this.$message({ message: "请选择场馆", type: 'error', customClass: "toast", duration: 2000 });
                return
            }
            if (!this.enterInfo.teacher_id) {
                this.$message({ message: "请选择教练", type: 'error', customClass: "toast", duration: 2000 });
                return
            }
            if (!this.enterInfo.reserve_date) {
                this.$message({ message: "请选择日期", type: 'error', customClass: "toast", duration: 2000 });
                return
            }
            if (!this.enterInfo.start_time) {
                this.$message({ message: "请选择预约起始时间", type: 'error', customClass: "toast", duration: 2000 });
                return
            }
            if (!this.enterInfo.end_time) {
                this.$message({ message: "请选择预约结束时间", type: 'error', customClass: "toast", duration: 2000 });
                return
            }


            this.loading = true
            let data = { ...this.enterInfo }
            data.openid = this.openid
            data.pmid = this.pmid
            data.reserve_type = this.type
            this.$http.post("/api/reverse_edit", data).then(res => {
                this.$message({
                    message: "预约成功！",
                    type: 'success',
                    customClass: "toast",
                    duration: 5000
                });
                this.loading = false
                this.goPage()
            })
        },
        goPage() {
            this.$router.push("/h5_reserve_list?openid=" + this.openid + "&pmid=" + this.pmid + "&type=" + this.type)
        },

    }

};
</script>

<style scoped>
.el-divider--horizontal {
    margin: 16px 0;
}

.h5bg {

    background-image: url(../../../public/img/xiantiao.jpg);
    background-size: cover;
    background-repeat: no-repeat;
    height: 100vh;
    overflow: auto;
}

.remove {
    width: 30px;
    height: 30px;
    position: absolute;
    top: -10px;
    right: -10px;
    background-color: #fff;
    border-radius: 50%;
    overflow: hidden;
}

.remove img {
    width: 100%;
    height: 100%;
}

.add {
    width: 40px;
    height: 40px;
    margin: 0 auto;
}

.add img {
    width: 100%;
    height: 100%;
}
</style>

<style>
.el-form--label-top .el-form-item__label {
    margin-bottom: 0;
    padding: 0;
}

.toast {
    width: 80%;
    min-width: 10% !important;
    max-width: 350px !important;
}

.imgaddbtn {
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
    border: 1px dotted #ccc;
    font-size: 30px;
    cursor: pointer;
}

.imgremove {
    width: 20px;
    height: 20px;
    line-height: 20px;
    text-align: center;

    cursor: pointer;
    position: absolute;
    top: -5px;
    right: -5px;
    color: #ccc;
}

.imgremove:hover {
    color: orange;
}
</style>